import React from 'react';
import PropTypes from 'prop-types';
import { StyledSelectedFilter } from './SelectedFilter.styles';

export default function SelectedFilter({ label, ...otherProps }) {
  return (
    <StyledSelectedFilter
      label={label}
      variant='outlined'
      clickable
      {...otherProps}
    />
  );
}

SelectedFilter.propTypes = {
  label: PropTypes.string,
};
